// extracted by mini-css-extract-plugin
export default {"search":"Search_search__+kwX4","searchForm":"Search_searchForm__Z1iUy","userChat":"Search_userChat__12L6S"};